// ===== RA Gift Animation System v3.9 — Single Select + Size Picker =====
(function() {
  var giftProgress = document.querySelector('.ra-gift-progress');
  if (!giftProgress) return;

  var tiersData = JSON.parse(giftProgress.dataset.giftTiers || '[]');
  var giftModal = document.getElementById('ra-gift-modal');
  var giftFill = document.getElementById('ra-gift-fill');
  var giftText = document.getElementById('ra-gift-text');
  var giftItemsEl = document.getElementById('ra-gift-items');
  var giftAddBtn = document.getElementById('ra-gift-add-btn');
  var confettiContainer = document.getElementById('ra-confetti');
  var giftClaimBtn = document.getElementById('ra-gift-claim-btn');

  var giftProductData = {};
  try {
    var rawGiftJSON = giftProgress.dataset.giftProducts || '{}';
    rawGiftJSON = rawGiftJSON.replace(/\s+/g, ' ').trim();
    giftProductData = JSON.parse(rawGiftJSON);
  } catch(e) {
    console.warn('RA Gift: Could not parse gift products JSON', e);
  }

  var previousTier = -1;
  var latestGiftTier = -1;
  var selectedGiftVariantId = null;
  var raIsInternalFetch = false;
  var raGiftRemoving = {};

  // Auto-removal threshold (cents). If the cart holds a gift and the total
  // drops below this, the gift line is silently removed. 0 disables it.
  var giftMinCheckout = parseInt(giftProgress.dataset.giftMinCheckout || '0', 10);

  // Flat list of every gift product handle, concatenated from each tier's
  // .handles array in giftProductData ({tier2:{handles:[...]}, tier3:{...}}).
  var raGiftHandles = [];
  Object.keys(giftProductData).forEach(function(tierKey) {
    var tier = giftProductData[tierKey];
    if (tier && Array.isArray(tier.handles)) {
      raGiftHandles = raGiftHandles.concat(tier.handles);
    }
  });

  var initialCartHandles = [];
  try { initialCartHandles = JSON.parse(giftProgress.dataset.cartHandles || '[]'); } catch(e) {}
  var initialCartItems = initialCartHandles.map(function(h) { return { handle: h }; });

  var initialTotal = parseInt(giftProgress.dataset.cartTotal || '0', 10);

  function formatMoney(amountCents) {
    return '$' + Math.round(amountCents / 100).toLocaleString('es-MX');
  }

  // A cart line is a gift when it carries the _gift property OR its handle
  // matches a configured gift product. Mirrors the Liquid gift detection.
  function raItemIsGift(item) {
    if (!item) return false;
    if (item.properties && item.properties._gift) return true;
    return raGiftHandles.indexOf(item.handle || item.product_handle || '') !== -1;
  }

  // Silently remove any gift line from the cart when the total has dropped
  // below the configured minimum. Fires one /cart/change.js (quantity 0) per
  // gift line, guarded per-key so concurrent passes don't double-fire.
  function raRemoveBelowMinGifts(cartTotalCents, cartItems) {
    if (giftMinCheckout <= 0) return;
    if (typeof cartTotalCents !== 'number') return;
    if (cartTotalCents >= giftMinCheckout) return;
    if (!Array.isArray(cartItems)) return;
    cartItems.forEach(function(item) {
      if (!item || !item.key) return;
      if (!raItemIsGift(item)) return;
      if (raGiftRemoving[item.key]) return;
      raGiftRemoving[item.key] = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      })
        .then(function() {
          delete raGiftRemoving[item.key];
          if (typeof window.refreshCartPage === 'function') window.refreshCartPage();
          if (typeof window.updateSideCart === 'function') window.updateSideCart();
          if (typeof window.refreshCartPage !== 'function' && typeof window.updateSideCart !== 'function') {
            window.location.reload();
          }
        })
        .catch(function() { delete raGiftRemoving[item.key]; });
    });
  }

  function isBundleTierComplete(tier, cartItems) {
    var groups = tier.bundleGroups || [];
    if (tier.mode !== 'bundle' || groups.length === 0) return false;
    var cartHandles = cartItems.map(function(item) { return item.handle || item.product_handle || ''; });
    return groups.every(function(group) {
      if (Array.isArray(group)) {
        return group.some(function(handle) { return cartHandles.indexOf(handle) !== -1; });
      }
      return false;
    });
  }

  function getMissingBundleNames(tier, cartItems) {
    var groups = tier.bundleGroups || [];
    var names = tier.bundleNames || [];
    var cartHandles = cartItems.map(function(item) { return item.handle || item.product_handle || ''; });
    var missing = [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var found = Array.isArray(group) && group.some(function(h) { return cartHandles.indexOf(h) !== -1; });
      if (!found) {
        missing.push(names[i] && names[i].indexOf('Grupo') !== 0 ? names[i] : 'un producto');
      }
    }
    return missing;
  }

  function getBundleCompletionFraction(tier, cartItems) {
    var groups = tier.bundleGroups || [];
    if (groups.length === 0) return 0;
    var cartHandles = cartItems.map(function(item) { return item.handle || item.product_handle || ''; });
    var found = 0;
    groups.forEach(function(group) {
      if (Array.isArray(group) && group.some(function(h) { return cartHandles.indexOf(h) !== -1; })) found++;
    });
    return found / groups.length;
  }

  function isTierComplete(tier, totalPesos, cartItems) {
    if (tier.mode === 'bundle') return isBundleTierComplete(tier, cartItems);
    return totalPesos >= tier.threshold;
  }

  function getCurrentTier(totalPesos, cartItems) {
    cartItems = cartItems || [];
    var tier = -1;
    for (var i = 0; i < tiersData.length; i++) {
      if (i > 0 && tier < i - 1) break;
      if (isTierComplete(tiersData[i], totalPesos, cartItems)) tier = i;
    }
    return tier;
  }

  function updateGiftProgress(cartTotalCents, cartItems) {
    cartItems = cartItems || [];
    var totalPesos = cartTotalCents / 100;

    giftFill = document.getElementById('ra-gift-fill');
    giftText = document.getElementById('ra-gift-text');

    var segmentSize = 100 / tiersData.length;
    var pct = 0;
    for (var si = 0; si < tiersData.length; si++) {
      if (isTierComplete(tiersData[si], totalPesos, cartItems)) {
        pct += segmentSize;
      } else {
        if (tiersData[si].mode === 'bundle') {
          pct += segmentSize * getBundleCompletionFraction(tiersData[si], cartItems);
        } else {
          var prevThreshold = 0;
          if (si > 0 && tiersData[si - 1].mode !== 'bundle') prevThreshold = tiersData[si - 1].threshold;
          var tierRange = tiersData[si].threshold - prevThreshold;
          if (tierRange > 0) pct += segmentSize * Math.min(1, Math.max(0, (totalPesos - prevThreshold) / tierRange));
        }
        break;
      }
    }
    pct = Math.min(100, pct);
    if (giftFill) giftFill.style.width = pct + '%';

    var currentTier = getCurrentTier(totalPesos, cartItems);

    if (giftText) {
      if (currentTier >= tiersData.length - 1) {
        giftText.innerHTML = '&#127873; <strong>Todos los regalos desbloqueados</strong>';
      } else {
        var nextTier = tiersData[currentTier + 1] || tiersData[0];
        if (nextTier.mode === 'bundle') {
          var missing = getMissingBundleNames(nextTier, cartItems);
          if (missing.length > 0) {
            giftText.innerHTML = 'Agrega <strong>' + missing.join(' + ') + '</strong> ' + (nextTier.bundleMessage || 'para desbloquear tu regalo');
          } else {
            giftText.innerHTML = '&#127873; <strong>Todos los regalos desbloqueados</strong>';
          }
        } else {
          var remainingPesos = nextTier.threshold - totalPesos;
          var remainingCents = remainingPesos * 100;
          if (nextTier.type === 'shipping') {
            giftText.innerHTML = 'Agrega <strong>' + formatMoney(remainingCents) + '</strong> m\u00e1s para obtener env\u00edo gratis';
          } else {
            giftText.innerHTML = 'Agrega <strong>' + formatMoney(remainingCents) + '</strong> m\u00e1s para desbloquear tu regalo';
          }
        }
      }
    }

    document.querySelectorAll('.ra-gift-milestone').forEach(function(m) {
      var tierIdx = parseInt(m.dataset.tier, 10) - 1;
      if (tierIdx < 0 || tierIdx >= tiersData.length) return;
      var dot = m.querySelector('.ra-gift-dot');
      var isUnlocked = isTierComplete(tiersData[tierIdx], totalPesos, cartItems);
      if (isUnlocked) {
        if (dot) dot.classList.add('unlocked');
        m.classList.add('unlocked');
      } else {
        if (dot) dot.classList.remove('unlocked');
        m.classList.remove('unlocked');
      }
    });

    // Track the highest currently-complete GIFT tier so the manual claim
    // button (and milestone clicks) can reopen the picker for it.
    latestGiftTier = -1;
    for (var gi = tiersData.length - 1; gi >= 0; gi--) {
      if (tiersData[gi] && tiersData[gi].type === 'gift' && isTierComplete(tiersData[gi], totalPesos, cartItems)) {
        latestGiftTier = gi;
        break;
      }
    }
    if (giftClaimBtn) giftClaimBtn.hidden = (latestGiftTier < 0);

    if (currentTier > previousTier && currentTier >= 0) {
      var unlockedTier = tiersData[currentTier];
      setTimeout(function() {
        launchConfetti();
        if (unlockedTier.type === 'gift') showGiftModal(currentTier);
      }, 400);
    }
    previousTier = currentTier;

    // Auto-remove the gift if the cart total fell below the minimum. Only the
    // mutation-triggered calls (fetch/XHR interceptors) pass items with a real
    // line-item key, so removal is a no-op on the init call (no keys).
    raRemoveBelowMinGifts(cartTotalCents, cartItems);
  }

  function showGiftModal(tierIndex) {
    if (!giftModal || !giftItemsEl) return;
    var tierLabel = tiersData[tierIndex].label;
    var subtitle = giftModal.querySelector('.ra-gift-modal-subtitle');
    if (subtitle) subtitle.textContent = 'Elige tu ' + tierLabel.toLowerCase() + ' gratis';
    var tierKey = 'tier' + (tierIndex + 1);
    var tierData = giftProductData[tierKey];
    if (tierData && tierData.handles && tierData.handles.length > 0) {
      giftItemsEl.innerHTML = '<div style="padding:20px;text-align:center;color:#888;">Cargando...</div>';
      giftModal.classList.add('active');
      fetchProductsByHandles(tierData.handles);
    } else if (tierData && tierData.products && tierData.products.length > 0) {
      renderGiftProducts(tierData.products);
      giftModal.classList.add('active');
    } else {
      giftItemsEl.innerHTML = '<div style="padding:20px;text-align:center;color:#666;font-size:13px;">Tu regalo se agregar\u00e1 autom\u00e1ticamente al carrito</div>';
      giftModal.classList.add('active');
    }
  }

  function fetchProductsByHandles(handles) {
    var products = [];
    var pending = handles.length;
    handles.forEach(function(handle) {
      raIsInternalFetch = true;
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          raIsInternalFetch = false;
          products.push({
            title: p.title,
            image: p.featured_image,
            variants: p.variants.map(function(v) {
              return { id: v.id, title: v.title, image: v.featured_image || p.featured_image, available: v.available };
            })
          });
          pending--;
          if (pending === 0) renderGiftProducts(products);
        })
        .catch(function() { raIsInternalFetch = false; pending--; if (pending === 0) renderGiftProducts(products); });
    });
  }

  function renderGiftProducts(products) {
    var html = '';
    products.forEach(function(product, pIdx) {
      if (!product || !product.variants) return;
      var allVariants = product.variants;
      // Need at least one available variant to show
      var hasAvailable = allVariants.some(function(v) { return v.available; });
      if (!hasAvailable) return;

      var firstAvailable = allVariants.filter(function(v) { return v.available; })[0];
      var imgSrc = product.image || firstAvailable.image || '';
      var isDefaultTitle = allVariants.length === 1 && allVariants[0].title === 'Default Title';
      var hasMultipleSizes = allVariants.length > 1 && !isDefaultTitle;

      html += '<div class="ra-gift-item" data-product-index="' + pIdx + '" data-variant-id="' + firstAvailable.id + '">';
      html += '<div class="ra-gift-item-img"><img src="' + imgSrc + '" alt="' + product.title + '"></div>';
      html += '<div class="ra-gift-item-info">';
      html += '<div class="ra-gift-item-name">' + product.title + '</div>';

      if (hasMultipleSizes) {
        html += '<div class="ra-gift-item-size">';
        html += '<select class="ra-gift-size-select" aria-label="Talla">';
        allVariants.forEach(function(v) {
          var disabled = !v.available ? ' disabled' : '';
          var label = v.title + (!v.available ? ' (Agotado)' : '');
          var selected = v.id === firstAvailable.id ? ' selected' : '';
          html += '<option value="' + v.id + '"' + disabled + selected + '>' + label + '</option>';
        });
        html += '</select>';
        html += '</div>';
      }

      html += '<div class="ra-gift-item-price">Gratis</div>';
      html += '</div>';
      html += '<div class="ra-gift-item-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>';
      html += '</div>';
    });

    if (!html) {
      giftItemsEl.innerHTML = '<div style="padding:20px;text-align:center;color:#666;font-size:13px;">No hay regalos disponibles en este momento</div>';
      return;
    }
    giftItemsEl.innerHTML = html;
    selectedGiftVariantId = null;

    giftItemsEl.querySelectorAll('.ra-gift-item').forEach(function(item) {
      // Clicking the row selects/deselects this product (radio behavior)
      item.addEventListener('click', function(e) {
        // Don't toggle selection when interacting with the size dropdown
        if (e.target.closest('.ra-gift-size-select')) return;

        var wasSelected = this.classList.contains('selected');

        // Deselect all items first (radio behavior — only one gift per level)
        giftItemsEl.querySelectorAll('.ra-gift-item').forEach(function(el) {
          el.classList.remove('selected');
        });

        if (wasSelected) {
          // Toggling off
          selectedGiftVariantId = null;
        } else {
          // Select this one
          this.classList.add('selected');
          var sizeSelect = this.querySelector('.ra-gift-size-select');
          selectedGiftVariantId = sizeSelect ? sizeSelect.value : this.dataset.variantId;
        }

        if (giftAddBtn) giftAddBtn.disabled = !selectedGiftVariantId;
      });

      // When size changes, update the stored variant ID (if this item is selected)
      var sizeSelect = item.querySelector('.ra-gift-size-select');
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function(e) {
          e.stopPropagation();
          var parentItem = this.closest('.ra-gift-item');

          // Auto-select the product when changing its size
          if (!parentItem.classList.contains('selected')) {
            giftItemsEl.querySelectorAll('.ra-gift-item').forEach(function(el) {
              el.classList.remove('selected');
            });
            parentItem.classList.add('selected');
          }

          // Update image to match selected variant
          var selectedOption = this.options[this.selectedIndex];
          var vid = this.value;
          parentItem.dataset.variantId = vid;
          selectedGiftVariantId = vid;
          if (giftAddBtn) giftAddBtn.disabled = false;
        });
      }
    });

    if (giftAddBtn) giftAddBtn.disabled = true;
  }

  function closeGiftModal() { if (giftModal) giftModal.classList.remove('active'); }

  function addGiftToCart() {
    if (!selectedGiftVariantId) return;
    if (giftAddBtn) { giftAddBtn.disabled = true; giftAddBtn.textContent = 'AGREGANDO...'; }
    raIsInternalFetch = true;
    var items = [{ id: parseInt(selectedGiftVariantId, 10), quantity: 1, properties: { '_gift': 'true' } }];
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(r) { return r.json(); })
    .then(function() {
      raIsInternalFetch = false;
      closeGiftModal();
      if (giftAddBtn) giftAddBtn.textContent = 'AGREGAR REGALO GRATIS';
      if (typeof window.updateSideCart === 'function') { window.updateSideCart(); } else { window.location.reload(); }
    })
    .catch(function(err) {
      raIsInternalFetch = false;
      if (giftAddBtn) { giftAddBtn.disabled = false; giftAddBtn.textContent = 'AGREGAR REGALO GRATIS'; }
      console.error('Error adding gift:', err);
    });
  }

  function launchConfetti() {
    if (!confettiContainer) return;
    var colors = ['#DC9B4F', '#2A4432', '#666', '#999', '#ddd', '#111', '#333'];
    for (var i = 0; i < 60; i++) {
      var piece = document.createElement('div');
      piece.className = 'ra-confetti-piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.animationDelay = Math.random() * 0.8 + 's';
      piece.style.animationDuration = (1.5 + Math.random() * 1.5) + 's';
      piece.style.width = (4 + Math.random() * 6) + 'px';
      piece.style.height = (4 + Math.random() * 6) + 'px';
      piece.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
      confettiContainer.appendChild(piece);
      (function(p) { setTimeout(function() { p.remove(); }, 3500); })(piece);
    }
  }

  if (giftModal) {
    var closeBtn = giftModal.querySelector('.ra-gift-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeGiftModal);
    giftModal.addEventListener('click', function(e) { if (e.target === giftModal) closeGiftModal(); });
  }
  if (giftAddBtn) giftAddBtn.addEventListener('click', addGiftToCart);

  // Manual triggers for the gift-picker modal. The claim button and the
  // milestone dots live in the static (Liquid-rendered) widget markup, so
  // these one-time listeners survive cart AJAX updates that only swap the
  // gift TEXT/FILL nodes. latestGiftTier is kept current by updateGiftProgress.
  if (giftClaimBtn) {
    giftClaimBtn.addEventListener('click', function() {
      if (latestGiftTier >= 0) showGiftModal(latestGiftTier);
    });
  }
  document.querySelectorAll('.ra-gift-milestone').forEach(function(m) {
    var mTierIdx = parseInt(m.dataset.tier, 10) - 1;
    if (mTierIdx < 0 || mTierIdx >= tiersData.length) return;
    if (tiersData[mTierIdx] && tiersData[mTierIdx].type === 'gift') {
      m.addEventListener('click', function() {
        if (m.classList.contains('unlocked')) showGiftModal(mTierIdx);
      });
    }
  });

  var _raOrigFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    if (raIsInternalFetch) return _raOrigFetch.apply(this, args);
    var isCartUrl = url && (url.indexOf('/cart.js') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1);
    if (!isCartUrl) return _raOrigFetch.apply(this, args);
    return _raOrigFetch.apply(this, args).then(function(response) {
      response.clone().json().then(function(data) {
        if (data && typeof data.total_price === 'number') updateGiftProgress(data.total_price, data.items || []);
      }).catch(function() {});
      return response;
    });
  };

  var _raOrigXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    var self = this;
    if (url && typeof url === 'string' && (url.indexOf('/cart.js') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
      self.addEventListener('load', function() {
        try { var data = JSON.parse(self.responseText); if (data && typeof data.total_price === 'number') updateGiftProgress(data.total_price, data.items || []); } catch(e) {}
      });
    }
    return _raOrigXHROpen.apply(this, arguments);
  };

  document.addEventListener('shopify:section:load', function() {
    raIsInternalFetch = true;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(data) {
      raIsInternalFetch = false;
      if (data && typeof data.total_price === 'number') updateGiftProgress(data.total_price, data.items || []);
    }).catch(function() { raIsInternalFetch = false; });
  });

  window.__raUpdateGiftProgress = updateGiftProgress;

  var _observerActive = true;
  var _observerDebounce = null;
  var giftObserver = new MutationObserver(function() {
    if (!_observerActive) return;
    var newText = document.getElementById('ra-gift-text');
    if (newText && newText.textContent.indexOf('Cargando') !== -1) {
      if (_observerDebounce) clearTimeout(_observerDebounce);
      _observerDebounce = setTimeout(function() {
        _observerActive = false;
        raIsInternalFetch = true;
        fetch('/cart.js').then(function(r){return r.json();}).then(function(data){
          raIsInternalFetch = false;
          if (data && typeof data.total_price === 'number') {
            updateGiftProgress(data.total_price, data.items || []);
          }
          setTimeout(function(){ _observerActive = true; }, 500);
        }).catch(function(){ raIsInternalFetch = false; _observerActive = true; });
      }, 200);
    }
  });
  var cartPanel = document.querySelector('.custom-header--cart-panel');
  if (cartPanel) {
    giftObserver.observe(cartPanel, { childList: true, subtree: true });
  }

  try {
    previousTier = getCurrentTier(initialTotal / 100, initialCartItems);
    var savedPrev = previousTier;
    updateGiftProgress(initialTotal, initialCartItems);
    previousTier = savedPrev;
  } catch(e) {
    console.warn('RA Gift: Initial update error', e);
    raIsInternalFetch = true;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(data) {
      raIsInternalFetch = false;
      if (data && typeof data.total_price === 'number') {
        previousTier = getCurrentTier(data.total_price / 100, data.items || []);
        updateGiftProgress(data.total_price, data.items || []);
        previousTier = getCurrentTier(data.total_price / 100, data.items || []);
      }
    }).catch(function() { raIsInternalFetch = false; });
  }

  // The init updateGiftProgress() call above runs on initialCartItems, built
  // from data-cart-handles with NO line-item key, so raRemoveBelowMinGifts is
  // a no-op there. Fetch the live cart once (keyed items) to catch a cart that
  // loaded already below the minimum with a gift (e.g. a /cart/add permalink).
  // raIsInternalFetch guards it so the fetch interceptor does not recurse.
  if (giftMinCheckout > 0) {
    raIsInternalFetch = true;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      raIsInternalFetch = false;
      if (cart && typeof cart.total_price === 'number') {
        raRemoveBelowMinGifts(cart.total_price, cart.items || []);
      }
    }).catch(function() { raIsInternalFetch = false; });
  }
})();
